module.exports = __webpack_public_path__ + "static/media/el_inicio.50866173.md";